export type Operation = 'none' | 'add' | 'remove' | 'complete';

export interface IState {
  id: string;
  operation: Operation;
  isProcessing: boolean;
}

export enum ActionKind {
  OpenFermentationRemoveModal = 'OPEN_FERMENTATION_REMOVE_MODAL',
  OpenFermentationCreateModal = 'OPEN_FERMENTATION_CREATE_MODAL',
  OpenFermentationCompleteModal = 'OPEN_FERMENTATION_COMPLETE_MODAL',
  OpenAddBatchIntoFermentationModal = 'OPEN_ADD_BATCH_INTO_FERMENTATION_MODAL',
  ResetFermentationActionState = 'RESET_FERMENTATION_ACTION_STATE',
  ResetFermentationOperation = 'RESET_FERMENTATION_OPERATION',
}

export type Action =
  | {
      type: ActionKind.OpenFermentationRemoveModal;
      id: string;
    }
  | {
      type: ActionKind.OpenFermentationCompleteModal;
      id: string;
    }
  | {
      type: ActionKind.ResetFermentationActionState;
    }
  | {
      type: ActionKind.OpenAddBatchIntoFermentationModal;
      id: string;
    }
  | {
      type: ActionKind.ResetFermentationOperation;
    };
